module.exports = __webpack_public_path__ + "static/media/auction-bid-demo-t2.582ca5ae.nom";